import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { environment } from 'environments/environment';

@Component({
	selector: 'app-innovation-showcase',
	templateUrl: './innovation-showcase.component.html',
	styleUrls: ['./innovation-showcase.component.scss']
})
export class InnovationShowcaseComponent implements OnInit {

	public contentHeader;
	public category = [];

	constructor() { }

	ngOnInit(): void {

		this.contentHeader = {
			headerTitle: 'Innovation Showcase',
			actionButton: true,
			breadcrumb: {
				type: '',
				links: [
					{
						name: 'Innovation Showcase',
						isLink: true,
						link: '/innovation-showcase'
					}
				]
			}
		};

	}

}
